import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import OrganisationSwitcherModal from "../modals/OrganisationSwitcherModal";
import { getProfile } from "../../store/actions/profile.action";
import TokenHelper from "../../utils/helpers/tokenHelper";
import { SubMenuType } from "../../utils/helpers/constants";


const OrganisationSwitcher = ({ organisations }) => {
	const dispatch = useDispatch(), navigate = useNavigate(), params = useParams(), location = useLocation();
	const [getOrgSwitcherRender, setGetOrgSwitcherRender] = useState(false);


	const getSelectedOrganisation = () => {
		let selectedOrgFromCookie = TokenHelper.getSelectedOrg();
		let activeOrganisation = {}, isFav = organisations.find(each => each['is_favourite']);
		if (selectedOrgFromCookie) activeOrganisation = organisations.find(each => each['reference'] === selectedOrgFromCookie);
		else if (isFav) activeOrganisation = isFav;
		else if (organisations.length > 0) activeOrganisation = organisations[0];
		TokenHelper.saveSelectedOrg(activeOrganisation.reference);
		TokenHelper.saveUserRole(activeOrganisation.role.name);
		return activeOrganisation;
	}


	const setSelectedOrganisation = async organisation => {
		TokenHelper.saveOnboardingStatus("PENDING");
		TokenHelper.saveUserRole(organisation.role.name);
		TokenHelper.saveSelectedOrg(organisation.reference);
		TokenHelper.saveSelectedOrgCountry(organisation.country);
		await dispatch(getProfile());
		setBaseNavigation();
	};

	const setBaseNavigation = () => {
		if (location.pathname.toLowerCase().includes('/services/overview')) navigate(0);

		if (Object.entries(params).length > 0) {
			let path = location.pathname;
			for (let value of Object.values(params)) path = path.replace(`/${value}`, '');
			navigate(path);
		}
		else if (location.pathname.toLowerCase().includes(`/services/${SubMenuType.WAREHOUSE}/deliveries/create-trip`)) navigate(`/services/${SubMenuType.WAREHOUSE}/deliveries`);
		else navigate(0);
	}

	const getOrgSwitcher = () => setGetOrgSwitcherRender(false);
	const getOrgSwitcherModal = getOrgSwitcherRender ?
		<OrganisationSwitcherModal onchange={getOrgSwitcher} organisations={organisations}
			setOrganisation={setSelectedOrganisation}
			activeOrganisation={getSelectedOrganisation} /> : null;

	return (
		<div>
			{getOrgSwitcherModal}
			<button type="button" className="btn btn-outline-primary btn-icon-text"
				onClick={() => setGetOrgSwitcherRender(true)}>
				{getSelectedOrganisation().name} <i className="zmdi zmdi-caret-down zmdi-hc-lg ms-1"></i>
			</button>
		</div>
	)
}

export default OrganisationSwitcher;
